import { toast as sonnerToast, Toaster as SonnerToaster } from "sonner";
import { ToastUI } from "./toast-ui";
import type { ToastAction, ToastVariant } from "./types";

interface ToastOptions {
  description?: string;
  duration?: number;
  action?: ToastAction;
  /** Runs on every close: action click, manual dismiss or timeout. */
  onClose?: () => void;
}

export function Toaster(props: React.ComponentProps<typeof SonnerToaster>) {
  return <SonnerToaster offset={16} mobileOffset={24} {...props} />;
}

function showToast(
  variant: ToastVariant,
  title: string,
  options: ToastOptions = {},
) {
  return sonnerToast.custom(
    (id) => (
      <ToastUI
        id={id}
        title={title}
        description={options.description}
        variant={variant}
        action={options.action}
      />
    ),
    {
      duration: options.duration ?? 5000,
      onDismiss: options.onClose,
      onAutoClose: options.onClose,
    },
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export const toast = {
  success: (title: string, options?: ToastOptions) =>
    showToast("success", title, options),

  error: (title: string, options?: ToastOptions) =>
    showToast("error", title, options),

  information: (title: string, options?: ToastOptions) =>
    showToast("information", title, options),

  dismiss: (id?: string | number) => sonnerToast.dismiss(id),
};
